import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
export var getCookie = function getCookie(name) {
  var str = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.cookie;
  return (str.split('; ').filter(function (cookie) {
    return +cookie.indexOf("".concat(name, "=")) === 0;
  }).pop() || '').replace(/[^=]+=/, '');
};
export var getStrCookie = function getStrCookie(name, str) {
  return (str.split(';').filter(function (cookie) {
    return cookie.trim().indexOf("".concat(name, "=")) === 0;
  }).pop() || '').replace(/[^=]+=/, '');
};
export var setCookie = function setCookie(k, v) {
  var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    domain: 'zhuanzhuan.com',
    path: '/',
    expires: 365
  };
  var d = Object.keys(obj).map(function (k) {
    if (typeof obj[k] === 'number') {
      var expires = new Date();
      expires.setTime(expires.getTime() + obj[k] * 24 * 60 * 60 * 1000);
      obj[k] = expires.toGMTString();
    }
    return "".concat(k, "=").concat(obj[k]);
  }).join(';');
  document.cookie = "".concat(k, "=").concat(v, ";").concat(d);
};